import { render, staticRenderFns } from "./mainOeuvre.vue?vue&type=template&id=6b30f932&scoped=true"
import script from "./mainOeuvre.vue?vue&type=script&lang=js"
export * from "./mainOeuvre.vue?vue&type=script&lang=js"
import style0 from "./mainOeuvre.vue?vue&type=style&index=0&id=6b30f932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30f932",
  null
  
)

export default component.exports